import { render, staticRenderFns } from "./vendorsRequests.vue?vue&type=template&id=06d42264&scoped=true"
import script from "./vendorsRequests.vue?vue&type=script&lang=js"
export * from "./vendorsRequests.vue?vue&type=script&lang=js"
import style0 from "./vendorsRequests.vue?vue&type=style&index=0&id=06d42264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d42264",
  null
  
)

export default component.exports